<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="卡派建单" width="1500">
      <el-form :inline="false"  class="" style="text-align: left">
        <div class="flex flex-row-left flex-item-start">
          <div style="flex:1" >
            <el-form-item  label="卡派运单">
              <el-input style="width:200px" disabled v-model="formInline.trackNumber" placeholder="创建自动生成" ></el-input>
            </el-form-item>
            <el-form-item  label="发货仓库">
              <el-select
                  :disabled="disable"
                  v-model="formInline.warehouseCode"
                  filterable
                  allow-create
                  default-first-option
                  @change="getSelect"
                  :reserve-keyword="false"
                  placeholder="请选择仓库"
                  style="width: 200px"
              >
                <el-option
                    v-for="item in defaultOption"
                    :key="item.StoreNum"
                    :label="item.StoreName"
                    :value="item.StoreNum"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="发货人昵称">
              <el-input style="width:200px" disabled v-model="formInline.shipperName" ></el-input>
            </el-form-item>
            <el-form-item label="发货人地址">
              <el-input style="width:200px" disabled v-model="formInline.shipperAddress" ></el-input>
            </el-form-item>
            <el-form-item label="发货人城市">
              <el-input style="width:200px" disabled v-model="formInline.shipperCity" ></el-input>
            </el-form-item>
            <el-form-item label="发货人街区">
              <el-input style="width:200px" disabled v-model="formInline.shipperState" ></el-input>
            </el-form-item>
            <el-form-item label="发货人国家">
              <el-input style="width:200px" disabled v-model="formInline.shipperCountry" ></el-input>
            </el-form-item>
            <el-form-item label="注意项">
              <el-input style="width:200px" disabled v-model="formInline.shipperAttention" ></el-input>
            </el-form-item>
            <el-form-item label="发货人邮编">
              <el-input style="width:200px" disabled v-model="formInline.shipperZip" ></el-input>
            </el-form-item>
            <el-form-item label="发货人电话">
              <el-input style="width:200px" disabled v-model="formInline.shipperPhone" ></el-input>
            </el-form-item>
            <el-form-item label="发货人邮箱">
              <el-input style="width:200px" disabled v-model="formInline.shipperEmail" ></el-input>
            </el-form-item>
            <el-form-item label="订单参考号">
              <el-input style="width:200px" disabled v-model="formInline.shipperReferenceNumber" ></el-input>
            </el-form-item>
          </div>
          <div style="flex:1">
            <el-form-item label="收货人昵称">
              <el-input style="width:200px" disabled v-model="formInline.consigneeName" ></el-input>
            </el-form-item>
            <el-form-item label="收货人地址">
              <el-input style="width:200px"  v-model="formInline.consigneeAddress" ></el-input>
            </el-form-item>
            <el-form-item label="收货人城市">
              <el-input style="width:200px"  v-model="formInline.consigneeCity" ></el-input>
            </el-form-item>
            <el-form-item label="收货人州">
              <el-input style="width:200px"  v-model="formInline.consigneeState" ></el-input>
            </el-form-item>
            <el-form-item label="收货人国家">
              <el-input style="width:200px"  v-model="formInline.consigneeCountry" ></el-input>
            </el-form-item>
            <el-form-item label="注意项">
              <el-input style="width:200px"  v-model="formInline.consigneeAttention" ></el-input>
            </el-form-item>
            <el-form-item label="收货人邮编">
              <el-input style="width:200px"  v-model="formInline.consigneeZip" ></el-input>
            </el-form-item>
            <el-form-item label="收货人电话">
              <el-input style="width:200px"  v-model="formInline.consigneePhone" ></el-input>
            </el-form-item>
            <el-form-item label="收货人邮箱">
              <el-input style="width:200px"  v-model="formInline.consigneeEmail" ></el-input>
            </el-form-item>
            <el-form-item label="出库参考号">
              <el-input style="width:200px" disabled v-model="formInline.consigneeReferenceNumber" ></el-input>
            </el-form-item>
          </div>
        </div>
        <div >
          <div class="qwerty flex flex-item-start flex-row-left">
            <el-form-item label="预约发货时间">
              <el-date-picker
                  style="width:200px"
                  v-model="formInline.shipDate"
                  type="date"
                  placeholder="预约发货时间"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  @change = "changeDate"
              />
            </el-form-item>
            <el-form-item label="预约发货开始时间">
              <el-date-picker
                  style="width:200px"
                  v-model="formInline.shipReadyTime"
                  format="HH:mm"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  type="datetime"
                  placeholder="预约发货开始时间"
              />
            </el-form-item>
            <el-form-item label="预约发货结束时间">
              <el-date-picker
                  style="width:200px"
                  v-model="formInline.shipCloseTime"
                  format="HH:mm"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  type="datetime"
                  placeholder="预约发货结束时间"
              />
            </el-form-item>
          </div>
          <div class="asdfgh flex flex-item-start flex-row-left">
            <el-form-item label="货物数量">
              <el-input style="width:80px"  type="number"  v-model="formInline.shipItemPieces" ></el-input>
            </el-form-item>
            <el-form-item label="货物描述">
              <el-input style="width:200px"  v-model="formInline.shipItemDescription" ></el-input>
            </el-form-item>
            <el-form-item label="重量(英镑)">
              <el-input style="width:80px" type="number"  v-model="formInline.shipItemWeight" ></el-input>
            </el-form-item>
            <el-form-item label="重量(公斤)">
              <el-input style="width:80px" type="number"  v-model="formInline.shipItemKilos" ></el-input>
            </el-form-item>
            <el-form-item label="长">
              <el-input style="width:80px" type="number"   v-model="formInline.shipItemLength" ></el-input>
            </el-form-item>
            <el-form-item label="宽">
              <el-input style="width:80px" type="number"  v-model="formInline.shipItemWidth" ></el-input>
            </el-form-item>
            <el-form-item label="高">
              <el-input style="width:80px" type="number"  v-model="formInline.shipItemHeight" ></el-input>
            </el-form-item>
          </div>
          <el-form-item label="保险金额">
            <el-input style="width:200px" v-model="formInline.shipIsInsurance" ></el-input>
          </el-form-item>
        </div>
        <div class="flex flex-row-right flex-item-center">
          <el-button style="margin: 0 auto" type="primary" @click="submit" >保存</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,
  ElSelect,
  ElOption,ElDatePicker,ElMessage
} from "element-plus";
import {getNextWeekDay} from "../../public/js";
import {getStoreList,bestbuyMater,addCopilot} from "@/utils/api";
export default {
  name: "addCopilot",
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    ElSelect,
    ElOption,
    ElDatePicker
  },
  data(){
    return{
      dialogTableVisible:false,
      formInline:{
        materNum:"",
        warehouseCode:"US-SACO",
        shipperName:"SYLVOX-RII EXPRESS",
        shipperAddress:"14950 VALLEY VIEW AVE",
        shipperCity:"LA MIRADA",
        shipperState:"CALIFORNIA",
        shipperZip:"90638",
        shipperCountry:"UNITED STATES OF AMERICA",
        shipperAttention:"LUKA",
        shipperPhone:"6572554255",
        shipperEmail:"helena@sylvoxtv.com",
        shipperReferenceNumber:"",

        consigneeName:"",
        consigneeAddress:"",
        consigneeCity:"",
        consigneeState:"",
        consigneeZip:"",
        consigneeCountry:"",
        consigneeAttention:"",
        consigneePhone:"",
        consigneeEmail:"",
        consigneeReferenceNumber:"",

        shipItemPieces:"",
        shipItemDescription:"",
        shipItemWeight:"",
        shipItemKilos:"",
        shipItemLength:"",
        shipItemWidth:"",
        shipItemHeight:"",
        shipIsInsurance:"1499",
      },
    }
  },
  beforeMount() {
    this.getStoreList()
  },
  methods:{
    getbestbuyMater(){
      bestbuyMater({materNum:this.formInline.materNum}).then(res=>{
        if(res && res.Data){
          this.formInline.shipItemWeight = res.Data.shipItemWeight;
          this.formInline.shipItemKilos = Math.ceil(res.Data.shipItemWeight* 0.4563);
          this.formInline.shipItemLength =res.Data.shipItemLength
          this.formInline.shipItemWidth =res.Data.shipItemWidth
          this.formInline.shipItemHeight =res.Data.shipItemHeight
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getSelect(value){
      console.log(value)
    },
    changeDate(value){
      this.formInline.shipReadyTime = value + " 14:00:00";
      this.formInline.shipCloseTime = value + " 16:00:00";
    },
    open(data){
      console.log(data)
      this.dialogTableVisible = true;
      this.formInline.materNum = data.materNum;
      this.formInline.salesRecordNumber = data.salesRecordNumber;
      this.formInline.shipperReferenceNumber = data.salesRecordNumber.includes('bb-') ? data.salesRecordNumber.split("bb-", 2)[1]:data.salesRecordNumber ;

      this.formInline.consigneeName = data.userInfo.name;
      this.formInline.consigneeAddress = data.address.street1;
      this.formInline.consigneeCity = data.address.city;
      this.formInline.consigneeState = data.address.province;
      this.formInline.consigneeZip = data.userInfo.postCode;
      this.formInline.consigneeCountry = data.address.country;
      this.formInline.consigneeAttention = data.userInfo.name;
      this.formInline.consigneePhone = data.userInfo.phone;
      this.formInline.consigneeEmail = data.userInfo.email;
      this.formInline.consigneeReferenceNumber = data.riiNumber

      this.formInline.shipDate = getNextWeekDay(true);
      this.formInline.shipReadyTime = this.formInline.shipDate + " 14:00:00";
      this.formInline.shipCloseTime = this.formInline.shipDate + " 16:00:00";

      this.formInline.shipItemPieces = data.Quantity;
      this.formInline.shipItemDescription =data.enMaterName;

      this.getbestbuyMater()
    },
    getStoreList(){
      getStoreList().then(res=>{
        console.log(res)
        this.defaultOption = res.Data
      }).catch(err=>{
        console.log(err)
      })
    },
    submit(){
      if(!this.formInline.consigneeName){
        ElMessage.warning("请填写收货人姓名")
        return
      }
      if(!this.formInline.consigneeAddress){
        ElMessage.warning("请填写收货人地址")
        return
      }
      if(!this.formInline.consigneeCity){
        ElMessage.warning("请填写收货人城市")
        return
      }
      if(!this.formInline.consigneeState){
        ElMessage.warning("请填写收货人州")
        return
      }
      if(!this.formInline.consigneeZip){
        ElMessage.warning("请填写收货人邮编")
        return
      }
      if(!this.formInline.consigneeCountry){
        ElMessage.warning("请填写收货人国家")
        return
      }
      if(!this.formInline.shipItemDescription){
        ElMessage.warning("请填写物品描述")
        return
      }
      addCopilot(this.formInline).then(res=>{
        console.log(res)
        ElMessage.success("添加成功")
        this.dialogTableVisible = false
        setTimeout(()=>{
          window.open("https://copilot.maersk.com/webairbill/Reprint.aspx?section=ship&subsection=reprint&PrintWhat=Pro&Housebill="+res.Data.trackNumber+"&ShipperCountry=UN&ConsigneeCountry=UN",'_blank')
        },500)
        setTimeout(()=>{
          window.open("https://copilot.maersk.com/webairbill/Reprint.aspx?section=ship&subsection=reprint&PrintWhat=Label&Housebill="+res.Data.trackNumber,'_blank')
        },1000)

        this.$emit("close")
      }).catch(err=>{
        this.$emit("close")
        console.log(err)
      })
    },
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 200px;
}
.qwerty{
  padding-left:50px;
  ::v-deep .el-form-item__label{
    width:150px;
  }
}
.asdfgh{
  padding-left:120px;
  ::v-deep .el-form-item__label{
    width:80px;
  }

}
</style>